<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="Slider"
            bc3="Add"
            path="slider"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><i class="far fa-user"></i
                                ></span>
                              </div>
                              <input
                                  type="text"
                                  v-model="name"
                                  class="form-control"
                                  :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                  name="name"
                                  placeholder="Name"
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('name')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label for="name-icon">Email</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <div class="input-group-prepend">-->
<!--                                <span class="input-group-text"-->
<!--                                  ><i class="far fa-envelope"></i-->
<!--                                ></span>-->
<!--                              </div>-->
<!--                              <input-->
<!--                                type="text"-->
<!--                                v-model="email"-->
<!--                                id="name-icon"-->
<!--                                class="form-control"-->
<!--                                :class="-->
<!--                                  errorBag.has('email') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                                name="email"-->
<!--                                placeholder="Email"-->
<!--                                v-validate="'required'"-->
<!--                              />-->
<!--                              <small-->
<!--                                v-show="errorBag.has('email')"-->
<!--                                class="invalid-feedback"-->
<!--                                >{{ "*" + errorBag.first("email") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label for="symbol-icon">Password</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <div class="input-group-prepend">-->
<!--                                <span class="input-group-text"-->
<!--                                  ><TargetIcon-->
<!--                                /></span>-->
<!--                              </div>-->
<!--                              <input-->
<!--                                type="text"-->
<!--                                v-model="password"-->
<!--                                id="symbol-icon"-->
<!--                                class="form-control"-->
<!--                                :class="-->
<!--                                  errorBag.has('password') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                                name="password"-->
<!--                                placeholder="Password"-->
<!--                                v-validate="'required'"-->
<!--                              />-->
<!--                              <small-->
<!--                                v-show="errorBag.has('password')"-->
<!--                                class="invalid-feedback"-->
<!--                                >{{ "*" + errorBag.first("password") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Link</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="link"
                                class="form-control"
                                :class="
                                  errorBag.has('link') ? 'is-invalid' : ''
                                "
                                name="link"
                                placeholder="Link"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('link')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("link") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Image</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="custom-file">
                                <small
                                  v-show="errorBag.has('image')"
                                  class="invalid-feedback"
                                  >{{ "*" + errorBag.first("image") }}</small
                                >
                                <input
                                  type="file"
                                  class="custom-file-input"
                                  :class="
                                    errorBag.has('image') ? 'is-invalid' : ''
                                  "
                                  id="customFile1"
                                  name="image"
                                  @change="onFileChanged"
                                  v-validate="'required'"
                                />
                                <label
                                  class="custom-file-label"
                                  for="customFile1"
                                  >{{
                                    image ? image.name : "Choose image"
                                  }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                class="custom-select"
                                name="type"
                                v-model="type"
                                :class="
                                  errorBag.has('type') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              >
                                <option value="">Please select item</option>
                                <option value="1">Mobile App</option>
                                <option value="2">Android App</option>
                                <option value="3">Ios App</option>
                                <option value="4">Web App</option>
                                <option value="5">Web Merchant</option>
                                <option value="6">All</option>
                              </select>
                              <small
                                v-show="errorBag.has('type')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("type") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Description</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <textarea
                                  class="form-control"
                                  v-model="description"
                                  name="description"
                              >
                      </textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.push({ name: 'slider' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { TargetIcon, Edit3Icon, CommandIcon } from "vue-feather-icons";
export default {
  components: {
    TargetIcon,
    Edit3Icon,
    CommandIcon
  },
  mounted() {},
  data() {
    return {
      name: "",
      link: "",
      description: "",
      email: "",
      password: "",
      image: null,
      type: "",
      loading: false,
      size: "10px"
    };
  },
  methods: {
    onFileChanged(event) {
      this.image = event.target.files[0];
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = new FormData();
          data.append("image", this.image, this.image.name);
          data.append("name", this.name);
          data.append("link", this.link);
          // data.append("email", this.email);
          // data.append("password", this.password);
          data.append("type", this.type);
          data.append("description", this.description);
          data.append("uri", 'v1/create-slider');
          this.makeRequest("post", "v1/create-slider", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("slider");
                    if (typeof storeData.firstPageData.data != "undefined") {
                      storeData.firstPageData.data.unshift(responseData);
                      storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                      if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                        storeData.firstPageData.data.pop();
                      }
                      storeData.key = "slider";
                      delete storeData.otherPageData;
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "slider",
                      // params: { add: true }
                    });
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

